import { Check, Lock } from "lucide-react";
import { CheckoutButton } from "@/components/CheckoutButton";
import { Reveal } from "@/components/Reveal";
import { ChapterLabel } from "@/components/ChapterLabel";
import { PRECIO_MENSUAL } from "@/config";

const incluye = [
  "Acceso a la comunidad privada de WhatsApp.",
  "Conversaciones diarias con otros miembros.",
  "Espacio para compartir pensamientos y experiencias.",
  "Normas y moderación para cuidar la convivencia.",
  "Acceso mientras la suscripción permanezca activa.",
  "Cancelación sencilla, sin permanencia.",
];

export const Precio = () => (
  <section className="relative overflow-hidden bg-[#0E1628] px-5 py-24 md:py-32">
    <div
      className="pointer-events-none absolute left-1/2 top-1/2 h-[480px] w-[760px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#7C6CF0]/[0.08] blur-[130px]"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-[1100px]">
      <ChapterLabel number="07" testId="chapter-precio" />
      <Reveal>
        <h2 className="max-w-3xl text-3xl font-semibold tracking-tight text-[#F5F1EA] md:text-5xl">
          Un espacio al que volver cada día.
        </h2>
      </Reveal>

      <Reveal delay={0.1} className="mt-12 flex justify-center">
        <div
          data-testid="precio-card"
          className="w-full max-w-xl rounded-3xl border border-[#8B7CF6]/30 bg-[#131D33] p-8 shadow-[0_16px_60px_rgba(124,108,240,0.12)] md:p-12"
        >
          <span className="inline-block rounded-full bg-[#8B7CF6]/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#8B7CF6]">
            Suscripción mensual
          </span>
          <h3 className="mt-5 font-[Fraunces] text-3xl font-semibold tracking-tight text-[#F5F1EA]">
            Comunidad privada
          </h3>

          <div className="mt-6 flex items-end gap-2">
            <span
              data-testid="precio-amount"
              className="font-[Fraunces] text-6xl font-semibold tracking-tight text-[#F5F1EA] md:text-7xl"
            >
              {PRECIO_MENSUAL}&nbsp;€
            </span>
            <span className="pb-2 text-sm font-medium text-[#9AA6BE]">
              al mes
            </span>
          </div>

          <ul className="mt-8 space-y-3.5 border-t border-[#22304D] pt-8">
            {incluye.map((item) => (
              <li key={item} className="flex items-start gap-3">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#8B7CF6]/15 text-[#8B7CF6]">
                  <Check className="h-3 w-3" strokeWidth={3} />
                </span>
                <span className="text-sm leading-relaxed text-[#E8E4DC]">
                  {item}
                </span>
              </li>
            ))}
          </ul>

          <div className="mt-10 flex flex-col items-center">
            <CheckoutButton testId="cta-precio-join" origen="precio" className="w-full sm:w-auto">
              Entrar en la comunidad — {PRECIO_MENSUAL} €/mes
            </CheckoutButton>
            <p className="mt-5 flex items-center gap-2 text-xs text-[#6B7690]">
              <Lock className="h-3.5 w-3.5" strokeWidth={1.5} />
              Pago mensual seguro mediante Stripe.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
